import { Component, computed, input } from '@angular/core';
import { resolveCalloutColor } from '../../callout-colors';
import {
    parseStatsEntries,
    resolveStatsColumns,
    resolveStatsStyle,
    statEntryHasContent,
} from '../../stats-options';

/**
 * Grade de indicadores só para LEITURA: lixeira, favoritos e a prévia antiga. Desenha os
 * cards como o PDF (mesmos estilos e cores de `items/stats.css`), pulando os vazios e
 * sem passar de um card por coluna.
 */
@Component({
    selector: 'stats-grid',
    templateUrl: 'stats-grid.component.html',
    styleUrl: 'stats-grid.component.scss',
})
export class StatsGridComponent {
    /** `value` cru do item (lista de `{ value, label }`). */
    public value = input<unknown>();
    public columns = input<number | null | undefined>();
    public styleKey = input<string | null | undefined>();
    public color = input<string | null | undefined>();

    public entries = computed(() => parseStatsEntries(this.value()).filter(statEntryHasContent));
    public resolvedColumns = computed(() =>
        Math.min(resolveStatsColumns(this.columns()), Math.max(this.entries().length, 1))
    );
    public resolvedStyle = computed(() => resolveStatsStyle(this.styleKey()));
    public family = computed(() => resolveCalloutColor(this.color()));
}
